import { RootState } from '@/Redux/RootReducer';
import { createSelector } from 'reselect';
import { DocumentCategoriesDataState } from './reducer';
import { DocumentSegmentType } from '@/Enums/_Microservices/OnlineArchive';

const documentCategoriesData = (root: RootState) => root.dynamicData.documentCategoriesData;

const documentCategories = createSelector(
  documentCategoriesData,
  (state: DocumentCategoriesDataState) => state.documentCategories,
);

const documentCategoryOptions = (documentSegment?: DocumentSegmentType) =>
  createSelector(documentCategories, (state) => {
    return (
      state
        .filter((item) => item.documentSegment === documentSegment)
        ?.map((item) => ({ key: item.id, value: item.name })) ?? []
    );
  });

const documentSubCategoryOptions = (documentCategory?: number | string) =>
  createSelector(documentCategories, (state) => {
    return (
      state
        .find((item) => item.id == documentCategory)
        ?.documentSubcategories.map((item) => ({ key: item.id, value: item.name })) ?? []
    );
  });

export const documentCategoriesDataSelectors = {
  documentCategories,
  documentCategoryOptions,
  documentSubCategoryOptions,
};
